import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ size = defaultSize, color = defaultIconColor, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      d="M17 9v7.5a4.5 4.5 0 1 1-9 0V6a3 3 0 1 1 6 0v7.5a1.5 1.5 0 0 1-3 0V9h0"
      stroke={color}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    />
  </svg>
);
